class CollectionScrollPosition {
  constructor () {
    // Last clicked item data
    this.lastClickedItemHrefKey =
      'collectionScrollPosition-lastClickedItemHref'
    this.lastClickedItemHref = sessionStorage.getItem(
      this.lastClickedItemHrefKey,
    )

    // Last visited url data
    this.lastVisitedUrlsKey =
      'collectionScrollPosition-lastVisitedCollectionUrl'
    this.lastVisitedUrls = sessionStorage.getItem(this.lastVisitedUrlsKey)

    this.currentUrl = this.urlToPathName(window.location.href)
    this.restoreScrollPosition = this.restoreScrollPosition.bind(this)

    this.initialise()
  }

  initialise () {
    if (this.currentUrl.includes('/collections/')) {
      this.handleCollectionTemplate()
    } else if (this.currentUrl.includes('/products/')) {
      this.handleProductTemplate()
    } else {
      this.clearData()
    }
  }

  handleCollectionTemplate () {
    let previousUrls = []

    try {
      previousUrls = JSON.parse(this.lastVisitedUrls)
      if (!Array.isArray(previousUrls)) previousUrls = []
    } catch (e) {
      previousUrls = []
    }

    const lastVisited = previousUrls[previousUrls.length - 1]

    this.lastVisitedCollectionUrl = this.currentUrl
    this.updateLastVisitedUrls(this.currentUrl)

    // Disable browser's native scrollRestoration
    if ('scrollRestoration' in history) {
      history.scrollRestoration = 'manual'
    }

    if (lastVisited === this.currentUrl) {
      this.clearData()
    }

    this.captureScrollPosition()

    if (this.lastClickedItemHref && this.lastClickedItemHref !== 'undefined') {
      window.BAO.eventBus.addEventListener(
        window.BAO.EVENTS.COLLECTION.PRODUCT_RENDERED,
        this.restoreScrollPosition,
      )
    }
  }

  handleProductTemplate () {
    this.updateLastVisitedUrls(this.currentUrl)
  }

  restoreScrollPosition (event) {
    const { detail } = event
    const handle = detail.productHandle
    const href = `${window.routes.rootUrl}products/${handle}`

    if (href !== this.lastClickedItemHref) return

    // Retrieve and restore last position
    const maxTries = 20
    const scrollToElement = () => {
      const el = document.querySelector(
        `a[href="${this.lastClickedItemHref}"]`,
      )

      if (el) {
        requestAnimationFrame(() => {
          el.scrollIntoView({
            behavior: 'smooth',
            block: 'center',
            inline: 'center',
          })
          el.focus?.({ preventScroll: true })

          this.clearData()
        })
      } else {
        if (!this._scrollTries) this._scrollTries = 0
        if (this._scrollTries < maxTries) {
          this._scrollTries++
          setTimeout(scrollToElement, 100)
        } else {
          // Stop trying after maxTries
          this._scrollTries = 0
        }
      }
    }

    this._scrollTries = 0
    scrollToElement()
  }

  captureScrollPosition () {
    // Capture clicked item
    window.addEventListener('click', (e) => {
      const anchor = e.target.closest('a')
      const item = e.target.closest('[data-collection-filters-el="item"]')
      if (!anchor || !item) return

      e.preventDefault()

      const href = anchor.getAttribute('href')
      const page = item.getAttribute('data-page')

      sessionStorage.setItem(
        'collectionScrollPosition-lastClickedItemHref',
        href,
      )
      this.lastClickedItemHref = href

      if (page != null) {
        sessionStorage.setItem(
          'collectionScrollPosition-lastVisitedCollectionUrlPage',
          page,
        )

        const currentParams = new URLSearchParams(window.location.search)
        if (page !== '1') {
          currentParams.set('page', page)
        } else {
          currentParams.delete('page')
        }

        const newParams = currentParams.toString()
          ? `?${currentParams.toString()}`
          : ''

        const newUrl = `${window.location.pathname}${newParams}`
        history.pushState({ page }, '', newUrl)
      }

      window.location.href = href
    })

    // Capture beforeunload event
    window.addEventListener('beforeunload', () => {
      sessionStorage.setItem(
        this.lastClickedItemHrefKey,
        this.lastClickedItemHref || '',
      )
    })
  }

  updateLastVisitedUrls (url) {
    const array = this.lastVisitedUrls
      ? [...JSON.parse(this.lastVisitedUrls)]
      : []
    array.push(url)

    const lastItem = array[array.length - 1]
    const secondToLastItem = array[array.length - 2]

    if (lastItem === secondToLastItem) {
      // If the last two items are the same, we clear data
      this.clearData()
    } else if (
      lastItem?.includes('/collections/') &&
      secondToLastItem?.includes('/collections/')
    ) {
      // If the last two items are both collections, we clear data
      this.clearData()
    } else {
      sessionStorage.setItem(this.lastVisitedUrlsKey, JSON.stringify(array))
    }
  }

  clearData () {
    sessionStorage.removeItem(this.lastClickedItemHrefKey)
    sessionStorage.removeItem(this.lastVisitedUrlsKey)
    this.lastClickedItemHref = null
    this.lastVisitedUrls = null
  }

  urlToPathName (url) {
    const object = new URL(url)
    return object.pathname
  }
}

document.addEventListener('DOMContentLoaded', () => {
  window.BAO.collectionScrollPosition = new CollectionScrollPosition()
})
